import { ContractSuretyType, SuretyAccountId } from "@inrev/common";
import { Separator } from "@portal/components/ui/Separator";
import { TruncatedLabel } from "@portal/components/ui/TruncatedLabel";
import { useNavigate } from "react-router-dom";
import { bondRequestTypeLabelMap } from "../../../constants";

export const BondRequestTitle = ({
	request,
	bidBond,
}: {
	request: {
		suretyAccountId: SuretyAccountId;
		principal: { name: string };
		contractSuretyType: ContractSuretyType;
	};
	bidBond?: { number: string };
}) => {
	const navigate = useNavigate();
	return (
		<div className="flex items-center space-x-[10px] cursor-default min-w-0">
			<span className="shrink-0">
				{bondRequestTypeLabelMap[request.contractSuretyType]} Bond Request
				{request.contractSuretyType === ContractSuretyType.bid_to_final &&
				bidBond?.number !== undefined
					? ` from Bid Bond ${bidBond?.number}`
					: ""}
			</span>
			<Separator orientation="vertical" className="bg-gray-300 h-[18px] shrink-0" />
			<TruncatedLabel
				label={request.principal.name}
				className="min-w-0 flex-1 text-secondary font-normal cursor-pointer hover:underline"
				onClick={() => navigate(`/accounts/${request.suretyAccountId}`)}
			/>
		</div>
	);
};
